import type { EditorCommand } from '@atlaskit/editor-common/types';
import type { AddRemixHistoryStackEntryPayload } from '@atlassian/malleable-ui-components/types';

import {
	type RemixHistoryPluginMeta,
	remixHistoryPluginKey,
} from '../pm-plugins/remix-history/remix-history-plugin';

export function makeAddRemixHistoryStackEntryCommand(
	options: AddRemixHistoryStackEntryPayload,
): EditorCommand {
	return ({ tr }) => {
		tr.setMeta(remixHistoryPluginKey, {
			type: 'addHistoryStackEntry',
			payload: options,
		} satisfies RemixHistoryPluginMeta);
		return tr;
	};
}
